import { Swiper } from 'swiper';
import { Pagination } from 'swiper/modules';

export default class{

    /**
     * constructor
     */
    constructor(){
        this.slider = document.querySelectorAll('[data-product-voices-slider]');
    }

    /**
     * init
     */
    init(){
        this.slider.forEach(slider => {
            const pagination = slider.querySelector('[data-product-voices-pagination]');

            new Swiper(slider, {
                modules: [Pagination],
                slidesPerView: 1,
                spaceBetween: 20,
                speed: 500,
                loop: true,
                pagination: {
                    el: pagination,
                    clickable: true
                }
            });
        });
    }
}